(ns rothko.theme.sandi.link
  (:require [garden.color :refer [darken]]
            [rothko.theme.sandi.colours :as sandi-colours]))

(def link
  {:default
   {:color (:orange sandi-colours/colours)
    :color--hover (darken (:orange sandi-colours/colours) 15)}})
